import { FC } from 'react';

import AppLayout from 'common/components/layouts/app-layout';
import CustomHeader from 'common/components/layouts/custom-header/custom-header';
import { translate } from 'common/config/i18n';

import { AuthenticationNav } from './authentication-nav';

const AuthLayout: FC = ({ children }) => {
  return (
    <AppLayout CustomNavBar={AuthNavBar}>
      <CustomHeader
        title="AstroPay OneTouch - Authentication"
        description={translate('login_astro')}
      />
      {children}
    </AppLayout>
  );
};

const AuthNavBar: FC = () => {
  return <AuthenticationNav />;
};

export default AuthLayout;
